import { TextField } from '@mui/material';
import { useTheme } from '@mui/material/styles';

const CustomTextFieldIndex = (props: any) => {
    const theme = useTheme();
    const colors = theme.palette;

    const fieldSx = {
        width: '100%',

        '& .MuiOutlinedInput-root': {
            backgroundColor: `${colors.inputNew.inputBackground} !important`,
            color: `${colors.inputNew.inputText} !important`,

            '& fieldset': {
                borderColor: `${colors.inputNew.inputBorder} !important`
            },

            '&:hover fieldset': {
                borderColor: `${colors.inputNew.inputBorderHover} !important`
            },

            '&.Mui-focused fieldset': {
                borderColor: `${colors.inputNew.inputBorderFocus} !important`
            },

            '& input, & textarea': {
                color: `${colors.inputNew.inputText} !important`,
                WebkitTextFillColor: `${colors.inputNew.inputText} !important`,

                '&::placeholder': {
                    color: `${colors.inputNew.inputPlaceholder} !important`,
                    WebkitTextFillColor: `${colors.inputNew.inputPlaceholder} !important`,
                    opacity: 1
                }
            }
        },

        '& .MuiInputBase-input': {
            color: `${colors.inputNew.inputText} !important`,
            WebkitTextFillColor: `${colors.inputNew.inputText} !important`
        },

        '& .MuiInputLabel-root': {
            color: `${colors.inputNew.inputPlaceholder} !important`
        },

        '& .MuiInputLabel-root.Mui-focused': {
            color: `${colors.inputNew.labelText} !important`
        }
    };

    // If type is 'number', use 'text' and restrict input
    const inputType = props.type === 'number' ? 'text' : props.type;

    // Handler to block non-digit input
    const handleKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (props.type === 'number' && !/\d/.test(e.key)) {
            e.preventDefault();
        }

        if (props.onKeyPress) props.onKeyPress(e);
    };

    // Conditionally add inputProps and onKeyPress for number fields only
    const mergedProps = {
        ...props,
        type: inputType,
        ...(props.type === 'number'
            ? {
                inputProps: {
                    ...props.inputProps,
                    inputMode: 'numeric',
                    pattern: '[0-9]*'
                },
                onKeyPress: handleKeyPress
            }
            : {})
    };

    return (
        <TextField
            {...mergedProps}
            sx={{
                ...fieldSx,
                ...props.sx
            }}
        />
    );
};

export default CustomTextFieldIndex;